// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"59a8b111","631":"67c7253e","635":"733f3c5f","953":"6b6c67ce"}[chunkId] + ".chunk.css";
};